export const WIDGET_IN_PROGRESS = 'Your widget will be ready soon!';

export const WIDGET_IN_PROGRESS_DESCRIPTION =
  'We’re fetching your latest episodes, transcribing them, and getting them ready so that we can deliver the best recommendations to your site visitors. This usually takes about 2 hours. We’ll email you when your widget is ready, in the meantime feel free to learn how to use it best:';
